import FlatEquationSolver from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/FlatEquationSolver';
import {
  STOICHIOMETRY_CALCULATION_EQUATIONS,
  StoichiometryVariable,
} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryEquations';
import PreciseDecimal from 'util/precise-decimal/PreciseDecimal';

const StoichiometrySolver = new FlatEquationSolver<StoichiometryVariable, PreciseDecimal>(
  STOICHIOMETRY_CALCULATION_EQUATIONS
);

export type StoichiometryCalculationVariableValues = Partial<Record<StoichiometryVariable, PreciseDecimal>>;

export default StoichiometrySolver;
